import httpClient from "@plugins/http";
import { cookieManager } from "@utils/cookie.manager";
import { ApiResponse } from "@apis/api.ts";
import { isEmpty } from "@utils/var.check.ts";

export interface LoginRequest {
  schoolcode: string;
  username: string;
  password: string;
  loginFlow?: string;
}

interface AuthResponse {
  code: "ok" | "error";
  errorMap: Record<string, string>;
  timestamp: string;
}

interface LoginResponse extends AuthResponse {
  data?: {
    redirectUrl?: string;
  };
}

export default {
  authCheck() {
    return httpClient.get(`/apis/auth/check`);
  },
  logout() {
    return httpClient.get(`/apis/auth/logout`);
  },
  login: ({
    schoolcode,
    username,
    password,
    loginFlow,
  }: LoginRequest): Promise<ApiResponse<LoginResponse>> => {
    const params = new URLSearchParams();
    params.append("schoolcode", schoolcode);
    params.append("username", username);
    params.append("password", password);

    if (loginFlow) {
      params.append("loginFlow", loginFlow);
    }

    const xsrfToken = cookieManager.getCookie("XSRF-TOKEN");
    if (xsrfToken) {
      params.append("_csrf", xsrfToken);
    }
    return httpClient.post(`/auth/login`, params, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });
  },
  async gateKeepingCheck(): Promise<ApiResponse<AuthResponse>> {
    return httpClient.get(`/apis/auth/gatekeeping/status`);
  },
  async edupassLogin(loginFlow?: string): Promise<ApiResponse<AuthResponse>> {
    return httpClient.get("/apis/auth/edupass/login", {
      params: isEmpty(loginFlow) ? {} : { loginFlow },
    });
  },

  pingSession() {
    return httpClient.get("/apis/auth/session/ping");
  },
};
